// extracted by mini-css-extract-plugin
export var email = "contact-module--email--5oJlv";
export var form = "contact-module--form--QAoFy";
export var formWrapper = "contact-module--formWrapper--Drveb";